import styled from "styled-components";
const DropdownItem = styled.div`
  padding: 4px 4px;
  font-size: 12px;
  &:hover {
      cursor: pointer;
      p { 
        text-decoration: underline;
      }
  }
`;
export default DropdownItem;
